import { useEffect } from 'react';
import { useGlobalState } from '../../../state/persistence';

const useProgress = (value?: number | boolean) => {
  const { dispatchAppStore, appStore } = useGlobalState();

  useEffect(() => {
    if (value !== appStore.progress) {
      dispatchAppStore('progress', value);
    }
  }, [value, appStore.progress, dispatchAppStore]);
};

export default useProgress;
